import Vue from 'vue'
import {
  DatePicker,
  Button,
  Checkbox,
  CheckboxGroup,
  Select,
  Input,
  Option,
  Switch,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Progress,
  Notification,
  Badge,
  Message,
  Loading,
  MessageBox,
  Slider,
  Dialog,
  Radio,
  Upload,
  Image,
  Table,
  TableColumn,
  Tooltip,
  Alert,
  Carousel,
  CarouselItem,
  Skeleton,
  SkeletonItem,
  Tabs,
  TabPane,
  Form,
  FormItem,
  Row,
  Col,
} from 'element-ui'
import VueWorker from 'vue-worker'
import Transitions from 'vue2-transitions'
import router from '@/router'
import store from '@/store'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import calendar from 'dayjs/plugin/calendar'
import relativeTime from 'dayjs/plugin/relativeTime'
import '@/scss/styles.scss'
import 'cropperjs/dist/cropper.css'
import 'pretty-checkbox/src/pretty-checkbox.scss'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import VueWait from 'vue-wait'
import VueStarRating from 'vue-star-rating'
import VueSweetalert2 from 'vue-sweetalert2'
import Toasted from 'vue-toasted'
import VueEsc from 'vue-esc'
import VueCropper from 'vue-cropperjs'
import wysiwyg from 'vue-wysiwyg'
import ToggleButton from 'vue-js-toggle-button'
import VueSelect from 'vue-select'
import Paginate from 'vuejs-paginate'
import VueClipboard from 'vue-clipboard2'
import PrettyCheck from 'pretty-checkbox-vue/check'
import PrettyRadio from 'pretty-checkbox-vue/radio'
import VTooltip from 'v-tooltip'
import VueCompositionAPI from '@vue/composition-api'
// Frequently used components
import Modal from '@/components/shared/modal/modal.component'
import VideoModal from '@/components/shared/modal-video/modal-video.component.vue'
import IframeModal from '@/components/shared/modal-iframe/modal-iframe.component.vue'
import pvContainer from '@/components/candidate/test/pv-container.component.vue'
import Spinner from '@/components/shared/spinner/spinner.component'
import ThumbnailVideo from '@/components/shared/thumbnail-video/thumbnail-video.component'
import customVideo from '@/components/shared/video-component/video-component.vue'
import { ClientTable } from 'vue-tables-2'
import VeeValidate from 'vee-validate'
import { setAxiosDefaultHeaders } from './utils/axios.js'
import { objectAssignPolyfill } from './utils'
import { GLOBAL_MIXIN } from '@/mixins/globals.mixin'
import VueLazyload from 'vue-lazyload'
import VueIntersect from 'vue-intersect-directive'
import draggable from 'vuedraggable'
import 'sweetalert2/dist/sweetalert2.min.css'
import { InlineSvgPlugin } from 'vue-inline-svg'

Vue.use(VueLazyload)
Vue.use(VueIntersect)
Vue.use(VueCompositionAPI)
Vue.use(VueSweetalert2)
Vue.use(VTooltip, { defaultDelay: 250 })
Vue.use(InlineSvgPlugin)
Vue.component('draggable', draggable)
Vue.component('v-select', VueSelect)
Vue.component('paginate', Paginate)
Vue.component('v-modal', Modal)
Vue.component('v-modal-video', VideoModal)
Vue.component('v-modal-iframe', IframeModal)
Vue.component('v-thumbnail-video', ThumbnailVideo)
Vue.component('custom-video', customVideo)
Vue.component('v-spinner', Spinner)
Vue.component('v-checkbox', PrettyCheck)
Vue.component('v-radio', PrettyRadio)
Vue.component('v-star-rating', VueStarRating)
Vue.component('vue-cropper', VueCropper)
Vue.component('pv-container', pvContainer)

Vue.use(wysiwyg, {
  hideModules: {
    image: true,
    underline: true,
    justifyCenter: true,
    justifyRight: true,
    justifyLeft: true,
    table: true,
    removeFormat: true,
    separator: true,
    headings: true,
    link: true,
    code: true,
  },
  forcePlainTextOnPaste: true, // this doesn't work because the package isn't updated to npm
})
Vue.use(Transitions)
Vue.use(Transitions)
Vue.use(VeeValidate)
Vue.use(ToggleButton)
Vue.use(VueWait)
Vue.use(ClientTable)
Vue.use(VueEsc)
Vue.use(VueStarRating)
Vue.use(VueClipboard)
Vue.use(Toasted, {
  iconPack: 'fontawesome',
  duration: 5000,
})
Vue.use(require('vue-chat-scroll'))
Vue.use(DatePicker)
Vue.use(Input)
Vue.use(Button)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.use(Radio)
Vue.use(Badge)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.use(Radio)
Vue.use(Row)
Vue.use(Col)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Progress)
Vue.use(Select)
Vue.use(Option)
Vue.use(Loading.directive)
Vue.use(Slider)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Image)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(Alert)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(VueWorker)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
locale.use(lang)

dayjs.extend(utc)
dayjs.extend(calendar)
dayjs.extend(relativeTime)

Object.defineProperties(Vue.prototype, {
  $date: {
    get() {
      return dayjs.utc
    },
  },
})

// To detect whether a video/element is being played
Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
  get: function () {
    return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2)
  },
})
objectAssignPolyfill()
setAxiosDefaultHeaders()
Vue.prototype.$eventHub = new Vue()
Vue.config.productionTip = false
import App from '@/components/App'
import { Validator } from 'vee-validate'
Vue.mixin(GLOBAL_MIXIN)

// custom validation rule for VeeValidate to check for invisible characters
Validator.extend('noInvisibleChars', {
  validate: value => !/[\u2000-\u200D\u00A0\uFEFF\u00AD\u2060\u200F\u200B]/.test(value),
  getMessage: field => `The ${field} field can not contain invisible characters`,
})

// If Url contains token and userType in url is recruiter then set the the local storage before moving forward
let params = new URLSearchParams(window.location.search)
let token = params.get('token')
let userType = params.get('userType')
if (token && userType === 'Recruiter') {
  localStorage.setItem('userType', 'Recruiter')
  localStorage.setItem('_verificationToken', token)
}

const app = new Vue({
  el: '#app',
  data: { routerLoading: false },
  router,
  store,
  wait: new VueWait({
    useVuex: true,
  }),
  render: h => h(App),
})
// window.Vue = app
router.beforeEach((to, from, next) => {
  app.routerLoading = true
  next()
})

router.afterEach(() => {
  app.routerLoading = false
})
